import { getInitialState } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  FCTaskList: [],
  prevPage: -1,
  nextPage: -1,
  activeTaskDetails: {},
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.RESET_STATE:
      return resetState(state, action);
    case ActionTypes.SET_FCTASK_LIST:
      return setFCList(state, action);
    default:
      return state;
  }
}

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setFCList = (state, action) => {
  return {
    ...state,
    FCTaskList: [...(action.payload?.tasks || [])],
    prevPage: action.payload?.page_response?.previous_page,
    nextPage: action.payload?.page_response?.next_page,
  };
};
